import { PrintersGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { AxiosResponse } from "axios";
import { useQuery } from "react-query";
import { MasterInstance } from "../../../../instance/axios";

export type PrinterOption = {
  value: string;
  label: string;
  group: string;
};

const getAutoCompleteKeyword = (keyword: string, query: any) =>
  MasterInstance.printersFindPost({
    query,
    search: keyword ? keyword : "",
    searchFields: ["code", "name"],
  }).then((res: AxiosResponse<PrintersGet200ResponseRowsInner[]>) => res.data);

export const usePrintersAutoComplete = (
  focus = false,
  keyword = "",
  query = {},
  options?: {
    onSuccess: (data: PrinterOption[]) => void;
  }
) => {
  return useQuery(
    ["printers-get-autocomplete", keyword],
    () => getAutoCompleteKeyword(keyword, query),
    {
      enabled: focus,
      select: (data: PrintersGet200ResponseRowsInner[]) =>
        data?.map((printer) => {
          return {
            value: String(printer.code),
            label: String(printer.name),
            group: String(printer.code),
          };
        }) ?? [],
      onSuccess: options?.onSuccess,
    }
  );
};

const getPrintersByCode = (code: string | null) =>
  MasterInstance.printersFindPost({
    ...(code && { search: code }),
    searchFields: ["code"],
  }).then((res: AxiosResponse<PrintersGet200ResponseRowsInner[]>) => res.data);

export const usePrintersCode = (
  enabled: boolean,
  code: string | null,
  options?: {
    onSuccess: (data?: PrinterOption[]) => void;
  }
) => {
  return useQuery(
    ["printers-get-code", code],
    () => getPrintersByCode(code),
    {
      enabled: enabled ?? false,
      select: (data: PrintersGet200ResponseRowsInner[]) =>
        data?.map((printer) => {
          return {
            value: String(printer.code),
            label: String(printer.name),
            group: String(printer.code),
          };
        }) ?? [],
      onSuccess: options?.onSuccess,
    }
  );
};
